import { getState, setState, subscribe } from '../state.js';
import { navigate, currentPath } from '../router.js';
import { api } from '../api.js';
import { STORAGE_KEYS } from '../config.js';
import { translate } from '../lib/i18n.js';

export function renderNav(container: HTMLElement): void {
  function isActive(linkPath: string): boolean {
    const path = currentPath();
    return path === linkPath || path.startsWith(linkPath + '/');
  }

  function activeClass(linkPath: string): string {
    return isActive(linkPath) ? ' nav__link--active' : '';
  }

  function render() {
    const { user, lang } = getState();

    container.className = 'nav';
    container.innerHTML = `
      <div class="nav__left">
        <a class="nav__wordmark" data-link="/graph">cross<svg class="wordmark-x" aria-hidden="true" viewBox="0 0 100 100"><line x1="12" y1="12" x2="88" y2="88" stroke="var(--signal)" stroke-width="18" stroke-linecap="round"/><line x1="88" y1="12" x2="12" y2="88" stroke="var(--acid)" stroke-width="18" stroke-linecap="round"/></svg>link</a>
        <div class="nav__lang">
          <span class="nav__lang-option ${!lang ? 'nav__lang-option--active' : ''}" data-lang="">EN</span>
          <span class="nav__lang-option ${lang === 'zh-CN' ? 'nav__lang-option--active' : ''}" data-lang="zh-CN">\u4E2D\u6587</span>
        </div>
      </div>
      <div class="nav__links">
        <a class="nav__link${activeClass('/graph')}" data-link="/graph">${translate('nav.graph', 'graph')}</a>
        <a class="nav__link${activeClass('/tree')}" data-link="/tree">${translate('nav.tree', 'tree')}</a>
        <a class="nav__link${activeClass('/timeline')}" data-link="/timeline">${translate('nav.timeline', 'timeline')}</a>
        <a class="nav__link${activeClass('/flow')}" data-link="/flow">${translate('nav.flow', 'flow')}</a>
        <a class="nav__link${activeClass('/recent')}" data-link="/recent">${translate('nav.recent', 'recent')}</a>
        <a class="nav__link${activeClass('/about')}" data-link="/about">${translate('nav.about', 'about')}</a>
        ${user ? `
          ${user.is_admin ? `<a class="nav__link${activeClass('/admin')}" data-link="/admin">${translate('nav.admin', 'admin')}</a>` : ''}
          <a class="nav__link nav__logout" data-action="logout">${translate('nav.logout', 'log out')}</a>
        ` : ``}
      </div>
    `;
  }

  function handleClick(e: MouseEvent) {
    const target = e.target as HTMLElement;

    const langOption = target.closest('[data-lang]') as HTMLElement | null;
    if (langOption) {
      e.preventDefault();
      const newLang = langOption.dataset.lang || null;
      if (newLang) {
        localStorage.setItem(STORAGE_KEYS.LANG, newLang);
      } else {
        localStorage.removeItem(STORAGE_KEYS.LANG);
      }
      setState({ lang: newLang });
      return;
    }

    const link = target.closest('[data-link]') as HTMLElement | null;
    if (link) {
      e.preventDefault();
      navigate(link.dataset.link!);
      return;
    }

    const action = target.closest('[data-action]') as HTMLElement | null;
    if (action) {
      e.preventDefault();
      const act = action.dataset.action;
      if (act === 'logout') {
        api.logout().then(() => {
          setState({ user: null });
          navigate('/graph');
        });
      } else if (act === 'login') {
        navigate('/login');
      }
    }
  }

  container.addEventListener('click', handleClick);
  render();
  subscribe('user', render);
  subscribe('lang', render);
  window.addEventListener('routechange', render);
}
